import React, { Component } from 'react';
import { message } from 'antd';
import { connect } from 'react-redux';
import { queryTaskInfo } from '@api/task';
import localDb from '@util/localDb';
import PageEdit from '../spTask/PageSubmit'; // 引入任务详情页
import PageOpen from './PageOpen';

class PageInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataInfo: {},
    };
  }

  componentWillMount() {
    this.userUuid = localDb.get('userUuid');
  }

  componentDidMount() {
    this.getTaskInfo();
  }

  getTaskInfo = () => {
    queryTaskInfo({
      uuid: this.props.params.uuid,
    }).then(res => {
      if (res.statusCode === 200) {
        res.data.createUser = res.data.executives[0].userUuid;
        this.setState({
          dataInfo: res.data,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  render() {
    const { dataInfo } = this.state;
    if (dataInfo.uuid && !dataInfo.instance && this.userUuid === dataInfo.createUser) {
      return <PageEdit {...this.props} />;
    }
    if (dataInfo.uuid) {
      return <PageOpen data={dataInfo} {...this.props} />;
    }
    return <span />;
  }
}
export default connect(state => ({
  expendType: state.expend_type,
  company: state.company_list,
}))(PageInfo);



// WEBPACK FOOTER //
// ./src/components/task/taskCheck/PageInfo.js